import { Component, OnInit } from '@angular/core';
import { QuestionBankService } from 'src/app/shared/services/question-bank/question-bank.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-test-status',
  templateUrl: './test-status.component.html',
  styleUrls: ['./test-status.component.scss']
})
export class TestStatusComponent implements OnInit {

  exams: any;
  questionBanks: any;
  constructor(
    private router: Router,
    private questionBankService: QuestionBankService,

  ) { }

  ngOnInit() {
    this.questionBankService.getDashboard()
    .subscribe(res => {
      this.questionBanks = res;
    });

}


onUploadClick(qb, lang) {

  var url = "question-bank/" + qb._id + "/langs/" + lang._id + "/upload";

  this.router.navigate([url]);
}

onReviewClick(qb, lang) {

  var url = "question-bank/" + qb._id + "/langs/" + lang._id + "/review";

  this.router.navigate([url]);
}

onEncryptionClick(qb, lang) {

  var url = "question-bank/" + qb._id + "/langs/" + lang._id + "/encryption";

  this.router.navigate([url]);
}

}
